// extracted by mini-css-extract-plugin
export default {"wrapper":"OvelContainerWrapper_wrapper__wYKMF"};